export default __webpack_public_path__ + "static/media/OBQ-sample.5b927f15.xlsx";